<ng-container *transloco="let t">
  <footer
    id="dashboard-footer"
    class="bg-ld-neutral-50 border-t border-ld-border py-4 w-full"
    [class.text-white]="isJvTheme() && useLightFooterText()"
    [style.background-color]="isJvTheme() ? 'var(--ld-footer-bg, var(--ld-header-bg, var(--color-ld-primary)))' : null"
    [class.text-ld-neutral-700]="isJvTheme() && !useLightFooterText()"
    [style.border-color]="isJvTheme() && useLightFooterText() ? 'transparent' : null"
  >
    <div
      id="dashboard-footer-container"
      class="max-w-[1440px] mx-auto px-8 flex flex-col gap-6 max-md:px-4 max-md:gap-4 max-md:items-center"
    >
      <!-- prettier-ignore -->
      <div id="dashboard-footer-links-mobile" class="flex flex-col items-center gap-2 md:hidden w-full">
        <div
          id="dashboard-footer-links-row1-mobile"
          class="font-general text-xs font-medium leading-4 text-black text-center w-full"
          [class.text-white/80]="isJvTheme() && useLightFooterText()"
          [class.text-ld-neutral-600]="isJvTheme() && !useLightFooterText()"
        >
          <a
            id="dashboard-footer-link-state-licensing-mobile"
            [href]="stateLicensingUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="underline cursor-pointer hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                    >{{ t('siteFooterMobileStateLicensing') }}</a>
                    <span class="px-1 text-ld-neutral-200" aria-hidden="true">|</span>
                    <a
                      id="dashboard-footer-link-privacy-security-mobile"
            [href]="privacyAndSecurityUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="underline cursor-pointer hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                    >{{ t('siteFooterMobilePrivacySecurity') }}</a>
                    <span class="px-1 text-ld-neutral-200" aria-hidden="true">|</span>
                    <a
                      id="dashboard-footer-link-terms-mobile"
            [href]="termsOfUseUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="underline cursor-pointer hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
          >{{ t('commonLinksTermsOfUse') }}</a>
        </div>
        <div
          id="dashboard-footer-links-row2-mobile"
          class="font-general text-xs font-medium leading-4 text-black text-center w-full"
          [class.text-white/80]="isJvTheme() && useLightFooterText()"
          [class.text-ld-neutral-600]="isJvTheme() && !useLightFooterText()"
        >
          <a
            id="dashboard-footer-link-accessibility-mobile"
            [href]="accessibilityUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="underline cursor-pointer hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                    >{{ t('siteFooterDisclosuresAccessibility') }}</a>
                    <span class="px-1 text-ld-neutral-200" aria-hidden="true">|</span>
                    <button
                      id="dashboard-footer-cookie-settings-mobile"
            type="button"
            class="bg-transparent border-0 p-0 underline cursor-pointer text-inherit hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
            (click)="openCookieSettings()"
                    >{{ t('siteFooterManageCookies') }}</button>
                    @if (!isJvTheme()) {
            <span class="px-1 text-ld-neutral-200" aria-hidden="true">|</span>
            <a
              id="dashboard-footer-link-lifetime-guarantee-mobile"
              [href]="lifetimeGuaranteeUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="underline cursor-pointer hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                        >{{ t('siteFooterDisclosuresLifetimeGuarantee') }}</a>
                        <span class="px-1 text-ld-neutral-200" aria-hidden="true">|</span>
            <button
              id="dashboard-footer-btn-disclaimers-mobile"
              type="button"
              class="bg-transparent border-0 p-0 underline cursor-pointer text-inherit hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
              (click)="openDisclaimers()"
                  >{{ t('siteFooterDisclosuresDisclaimers') }}</button>
                }
              </div>
            </div>

      <!-- prettier-ignore -->
      <div id="dashboard-footer-links-desktop" class="hidden md:flex justify-between gap-4">
        <p
          id="dashboard-footer-legal-links-left"
          class="font-general text-sm leading-5 text-black m-0 whitespace-nowrap"
          [class.text-white/80]="isJvTheme() && useLightFooterText()"
          [class.text-ld-neutral-600]="isJvTheme() && !useLightFooterText()"
        >
          <a
            id="dashboard-footer-link-state-licensing"
            [href]="stateLicensingUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                    >{{ t('siteFooterMobileStateLicensing') }}</a>
                    <span class="px-2 text-ld-neutral-500" aria-hidden="true">|</span>
                    <a
                      id="dashboard-footer-link-privacy-security"
            [href]="privacyAndSecurityUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                    >{{ t('siteFooterMobilePrivacySecurity') }}</a>
                    <span class="px-2 text-ld-neutral-500" aria-hidden="true">|</span>
                    <a
                      id="dashboard-footer-link-terms"
            [href]="termsOfUseUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
          >{{ t('commonLinksTermsOfUse') }}</a>
          <span class="px-2 text-ld-neutral-500" aria-hidden="true">|</span>
          <a
            id="dashboard-footer-link-accessibility"
            [href]="accessibilityUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                    >{{ t('siteFooterDisclosuresAccessibility') }}</a>
                    <span class="px-2 text-ld-neutral-500" aria-hidden="true">|</span>
                    <button
                      id="dashboard-footer-cookie-settings"
            type="button"
            class="bg-transparent border-0 p-0 underline cursor-pointer text-inherit hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
            (click)="openCookieSettings()"
                  >{{ t('siteFooterManageCookies') }}</button>
                </p>
        @if (!isJvTheme()) {
          <p
            id="dashboard-footer-legal-links-right"
            class="font-general text-sm leading-5 text-black m-0 whitespace-nowrap shrink-0"
          >
            <a
              id="dashboard-footer-link-lifetime-guarantee"
              [href]="lifetimeGuaranteeUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                        >{{ t('siteFooterDisclosuresLifetimeGuarantee') }}</a>
                        <span class="px-2 text-ld-neutral-500" aria-hidden="true">|</span>
            <button
              id="dashboard-footer-btn-disclaimers"
              type="button"
              class="bg-transparent border-0 p-0 underline cursor-pointer text-inherit hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
              (click)="openDisclaimers()"
                      >{{ t('siteFooterDisclosuresDisclaimers') }}</button>
                    </p>
        }
      </div>

      <div
        id="dashboard-footer-bottom-row"
        class="flex flex-nowrap items-center justify-between gap-4 max-md:flex-col max-md:items-center max-md:justify-center max-md:gap-2"
      >
        <div
          id="dashboard-footer-nmls"
          class="font-general text-[13px] leading-4 tracking-[0.26px] text-ld-neutral-500 m-0 max-md:text-center max-md:leading-4"
          [class.text-white/60]="isJvTheme() && useLightFooterText()"
          [class.text-ld-neutral-500]="isJvTheme() && !useLightFooterText()"
        >
          <p id="dashboard-footer-disclosures-hint" class="m-0 mb-1">
            {{ t('siteFooterDisclosuresIntro') }}
          </p>
          <!-- prettier-ignore -->
          <p id="dashboard-footer-nmls-text" class="m-0">
            @if (copyrightText()) {
              NMLS #{{ nmlsId() }} –
              <a
                id="dashboard-footer-link-nmls-consumer-access"
                [href]="nmlsConsumerAccessUrl()"
                target="_blank"
                rel="noopener noreferrer"
                class="underline hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                [class.text-white]="isJvTheme() && useLightFooterText()"
                [class.text-black]="!isJvTheme() || !useLightFooterText()"
                            >{{ t('siteFooterMobileNmlsConsumerAccess') }}</a>
                            | {{ copyrightText() }}
            } @else {
              {{ t('footerNmls') }} –
              <a
                id="dashboard-footer-link-nmls-consumer-access"
                [href]="nmlsConsumerAccessUrl()"
                target="_blank"
                rel="noopener noreferrer"
                class="underline hover:text-ld-neutral-700 touch-target focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
                [class.text-white]="isJvTheme() && useLightFooterText()"
                [class.text-black]="!isJvTheme() || !useLightFooterText()"
                            >{{ t('siteFooterMobileNmlsConsumerAccess') }}</a>
                            | {{ t('footerCopyright', { startYear: copyrightStartYear, year: currentYear }) }}
            }
          </p>
        </div>

        <div
          id="dashboard-footer-badges"
          class="flex items-center gap-4 shrink-0"
          [class.brightness-0]="isJvTheme() && useLightFooterText()"
          [class.invert]="isJvTheme() && useLightFooterText()"
          [class.opacity-60]="isJvTheme() && useLightFooterText()"
        >
          <img
            id="dashboard-footer-bbb-logo"
            [src]="bbbLogo"
            [alt]="t('footerBbbAlt')"
            class="block h-[33px] w-[88px] object-contain"
          />
          <img
            id="dashboard-footer-equal-housing-logo"
            [src]="equalHousingLogo"
            [alt]="t('footerEqualHousingAlt')"
            class="block w-9 h-9 object-contain"
          />
        </div>
      </div>
    </div>

    @if (showDisclaimersModal()) {
      <ld-base-modal
        [title]="'Disclaimers'"
        [size]="'medium'"
        ariaLabelledBy="disclaimers-modal-title"
        (closeModal)="closeDisclaimers()"
      >
        <div modal-content class="flex flex-col gap-4">
          <p id="dashboard-footer-disclaimers-testimonial" class="font-dm text-sm text-ld-neutral-700 leading-6 m-0">
            <strong>Testimonial disclosure</strong>
            – Compensation was not paid in exchange for any testimonial on this site. Individuals pictured may not be
            that of the endorsers and is for display purposes only.
          </p>
          <p id="dashboard-footer-disclaimers-refinance" class="font-dm text-sm text-ld-neutral-700 leading-6 m-0">
            <strong>Refinance disclosure</strong>
            – By refinancing the existing loan, the total finance charges may be higher over the life of the loan.
          </p>
          <!-- prettier-ignore -->
          <div class="flex flex-col gap-2">
            <a
              id="dashboard-footer-disclaimers-tx-consumer"
              [href]="txConsumerComplaintUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="block font-dm text-sm text-black underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
            >TX Consumer Complaint Disclosure</a>
            <a
              id="dashboard-footer-disclaimers-il-community"
              [href]="ilCommunityReinvestmentUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="block font-dm text-sm text-black underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
            >IL Community Reinvestment Act Notice</a>
            <a
              id="dashboard-footer-disclaimers-tx-servicing"
              [href]="txServicingUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="block font-dm text-sm text-black underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
            >TX Servicing Disclosure</a>
            <a
              id="dashboard-footer-disclaimers-ny-servicing"
              [href]="nyServicingUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="block font-dm text-sm text-black underline cursor-pointer hover:text-ld-neutral-700 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
            >NY Servicing Disclosure</a>
          </div>
        </div>

        <!-- prettier-ignore -->
        <div modal-footer>
          <button
            id="dashboard-footer-disclaimers-done"
            type="button"
            class="btn-primary-ld-purple"
            (click)="closeDisclaimers()"
          >{{ t('commonButtonsDone') }}</button>
        </div>
      </ld-base-modal>
    }
  </footer>
</ng-container>
